<prism-dialog
	id="sh-grant-access-dialog-container-div"
	[visible]="true"
	*transloco="let t; read: 'cloud.shared.elevated-access'"
>
	<div id="sh-grant-access-title-div" slot="dialog-title">
		{{ dataContent.title }}
	</div>
	<form [formGroup]="grantAccessFormGroup" id="sh-grant-access-content-form">
		<div id="sh-grant-access-confirm-text-div">
			<div id="sh-grant-access-description-1-div">
				{{ dataContent.description1 }}
			</div>
			@if (dataContent.description2) {
				<div id="sh-grant-access-description-2-div">
					{{ dataContent.description2 }}
					<a
						id="sh-grant-access-privacy-policy-link"
						class="prism-link"
						[href]="getFormattedUrl('PRIVACY_POLICY')"
						target="_blank"
					>
						{{ t('privacy-policy') }}
					</a>
					{{ dataContent.description3 }}
				</div>
			}
		</div>

		<div id="sh-elevated-access-duration-field-div">
			<prism-select
				required="true"
				formControlName="durationMinutes"
				id="sh-grant-access-duration-select-field"
				placement="bottom-start"
			>
				<span slot="label" id="sh-grant-access-duration-form-label">
					{{ dataContent.formLabel }}
				</span>
				<prism-menu>
					@for (duration of durationOptions; track duration.value) {
						<prism-menu-item
							[value]="duration.value"
							[id]="'sh-grant-access-duration-option-' + duration.value"
						>
							{{ t(duration.label, { value: duration.labelValue }) }}
						</prism-menu-item>
					}
				</prism-menu>
			</prism-select>
			@if (
				grantAccessFormGroup.get('durationMinutes')?.invalid &&
				grantAccessFormGroup.get('durationMinutes')?.touched
			) {
				<div class="prism-caption sh-grant-access-form-error-div" id="sh-grant-access-form-duration-error-div">
					@if (grantAccessFormGroup.get('durationMinutes')?.hasError('required')) {
						{{ t('duration-required') }}
					}
				</div>
			}
		</div>
	</form>
	<div id="sh-grant-access-action-buttons-div" slot="dialog-footer-buttons">
		<prism-button variant="text" (click)="closeDialog()" id="sh-grant-access-button-cancel">
			{{ t('cancel') }}
		</prism-button>
		<prism-button
			variant="text"
			[disabled]="grantAccessFormGroup.invalid"
			(click)="confirmGrantAccess()"
			id="sh-grant-access-grant-access-button"
		>
			{{ dataContent.buttonLabel }}
		</prism-button>
	</div>
</prism-dialog>
